export default function() {
  localStorage.removeItem('token')
  localStorage.removeItem('userInfo')
  localStorage.removeItem('pageTabs')
  location.reload()
}
